export default __webpack_public_path__ + "static/media/meeting.4d905429.jpg";